export enum VIEW_MODE {
  TODAY = 'Today',
  CYCLE = 'Cycle'
}

export enum TotalCallsSources {
  SLASH = 'Slash',
  AMEYO = 'Ameyo',
  SELF_CALL = 'Self'
}

export const TOTAL_CALLS_SOURCES_DATA = [
  TotalCallsSources.SLASH,
  TotalCallsSources.AMEYO,
  TotalCallsSources.SELF_CALL
];

export const TOTAL_CALLS_SOURCES = {
  [TotalCallsSources.SLASH]: {
    label: 'Slash',
    value: 'slash'
  },
  [TotalCallsSources.AMEYO]: {
    label: 'Ameyo',
    value: 'ameyo'
  },
  [TotalCallsSources.SELF_CALL]: {
    label: 'Self',
    value: 'self'
  }
};
